import { IcoClose } from './common/Icons.jsx';
import styles from './MoveTabSheet.module.css';
import { useAtrasCierra } from '../lib/atras.js';

/**
 * Menú de acciones secundarias.
 *
 * Reúne lo que antes eran seis u ocho iconos de 32 px en fila —impresora,
 * historial, devolución, cocina, PIN…— que en tablet chica se desbordaban y en
 * teléfono se comían una fila entera. Aquí cada acción mide 52 px y dice qué
 * hace con palabras; el encabezado se queda con lo que se usa cada minuto.
 *
 * `items`: [{ label, hint?, icon?, badge?, danger?, disabled?, onClick }]. Los
 * `null` se ignoran, para poder condicionar sin filtrar.
 */
export default function MenuSheet({ open, title = 'Más', items = [], onClose }) {
  useAtrasCierra(open, onClose);
  if (!open) return null;
  const visibles = items.filter(Boolean);

  return (
    <div className={styles.scrim} role="presentation" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className={styles.sheet} role="dialog" aria-modal="true" aria-label={title}>
        <div className={styles.head}>
          <h2 className={styles.title}>{title}</h2>
          <button className={styles.close} onClick={onClose} aria-label="Cerrar"><IcoClose size={16} /></button>
        </div>
        <div className={styles.lista}>
          {visibles.map((it) => (
            <button
              key={it.label}
              className={`${styles.fila} ${it.danger ? styles.filaDanger : ''}`}
              disabled={it.disabled}
              onClick={() => { onClose(); it.onClick?.(); }}
            >
              {it.icon && <span className={styles.filaIco}>{it.icon}</span>}
              <span className={styles.filaTexto}>
                <strong>{it.label}</strong>
                {it.hint && <small>{it.hint}</small>}
              </span>
              {it.badge ? <span className={styles.filaBadge}>{it.badge}</span> : null}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
